import { createContext, useContext } from "react";
//#region src/ui/dialog/context.tsx
const DialogContext = createContext(null);
const DialogContextProvider = DialogContext.Provider;
/** Returns the current dialog compound-component context. Throws outside a dialog root. */
function useDialogContext() {
	return useDialogContextFor("Dialog");
}
function useDialogContextFor(componentName) {
	const ctx = useContext(DialogContext);
	if (!ctx) throw new Error(`${componentName} compound components must be used within a ${componentName}.Root`);
	return ctx;
}
//#endregion
export { DialogContextProvider, useDialogContext, useDialogContextFor };

//# sourceMappingURL=context.js.map